import SectionHeading from "./SectionHeading";

const facts = [
  { label: "主要文本来源", value: "水浒传 / 金瓶梅", icon: "ri-book-2-line" },
  { label: "常见改编形态", value: "电影 / 剧集 / 舞台", icon: "ri-stack-line" },
  { label: "可浏览方向", value: "6 大类合集", icon: "ri-layout-grid-line" },
];

export default function OverviewSection() {
  return (
    <section id="overview" className="section-anchor w-full bg-background-50">
      <div className="w-full px-4 md:px-8 py-14 md:py-24">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div>
            <SectionHeading
              eyebrow="合集导读"
              title="什么是“潘金莲电影”这一检索方向"
              desc="潘金莲是中国古典小说中的人物，主要出自施耐庵《水浒传》与兰陵笑笑生《金瓶梅》。围绕这一人物，不同年代、不同地区陆续出现了大量影视与舞台改编，于是“潘金莲电影”逐渐成为一个题材化的合集检索方向。"
            />

            <p className="mt-5 text-sm md:text-base leading-relaxed text-foreground-700">
              它并不指向某一部固定影片，而是一组作品的统称：既包括从原著支线取材的电影，也包括以长篇形式展开的电视剧版本，
              还涵盖被反复翻拍的系列影片、地方剧种的舞台剧目，以及近年出现的网络影像与短剧。名称相近、主创各异的版本并存，
              正是这一题材最典型的特点。因此，本站先按方向与年代为它们归类，再给出可浏览的推荐与筛选入口。
            </p>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-3">
              {facts.map((f) => (
                <div
                  key={f.label}
                  className="rounded-lg bg-background-100 border border-background-200/70 p-4"
                >
                  <span className="w-9 h-9 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                    <i className={f.icon}></i>
                  </span>
                  <p className="mt-3 text-xs text-foreground-600 font-label">
                    {f.label}
                  </p>
                  <p className="mt-1 text-sm font-medium text-foreground-950">
                    {f.value}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="w-full h-[280px] md:h-[420px] rounded-lg overflow-hidden border border-background-200/70">
              <img
                src="https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20painting%20of%20a%20quiet%20old%20town%20street%20with%20wooden%20shutters%20and%20a%20stone%20lane%2C%20warm%20paper%20texture%2C%20muted%20vermillion%20and%20gold%20tones%2C%20literary%20serene%20atmosphere%2C%20no%20text&width=1200&height=900&seq=pjl-overview&orientation=landscape"
                alt="水墨风格的古镇街巷场景，呼应古典小说题材"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="hidden md:block absolute -bottom-6 -left-6 rounded-lg bg-foreground-950 text-background-50 px-5 py-4 border border-accent-500/40">
              <p className="text-xs text-accent-400 font-label">题材脉络</p>
              <p className="mt-1 font-heading text-lg">片厂 · 文艺 · 剧集 · 网络</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}